<template>
  <BaseModal
    :full-screen="isMobile"
    class="app-container"
    ui-refresh
    no-footer>
    <template #body>
      <h1>{{ selectedFormula?.name }}</h1>
      <StyleCarousel
        v-if="exampleItems.length > 0"
        :items="exampleItems"
        :visible-count="5">
        <template #default="{ item }">
          <h2 class="text-center my-xxl">
            {{ item?.name }}
          </h2>
        </template>
      </StyleCarousel>
    </template>
  </BaseModal>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import BaseModal from '@/components/global/BaseModal.vue'
import useScreenSize from '@shared/composables/screenSize.js'
import StyleCarousel from '@shared/components/ADORN/StyleCarousel.vue'
import { useOutfitGeneratorStore } from '@/stores/outfitGenerator.js'

const outfitGeneratorStore = useOutfitGeneratorStore()
const { exampleItems, selectedFormula } = storeToRefs(outfitGeneratorStore)
const { isMobile } = useScreenSize()
</script>

